// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"e6e832c6","162":"8b8b80d5","703":"e6e832c6"}[chunkId] + ".chunk.css";
};